export const addResultsMain = {
    namespaced: true,

    state: {
        session: null,
        sessionAttendance: null,
        healthStatuses: []
    },

    mutations: {
        sessionSave(state, data) {
            state.session = data;
        },

        sessionAttendanceSave(state, data) {
            state.sessionAttendance = data;
        },

        healthStatuses(state, data) {
            state.healthStatuses = [...data];
        },

        emptyStore(state) {
            Vue.set(state, 'healthStatuses', []);
            Vue.set(state, 'session', null);
        }
    }
};
